import React from 'react';
function WarningOutline(_ref) {
  let {
    color = '#335B70',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2L1 21h22M12 6l7.53 13H4.47M11 10v4h2v-4m-2 6v2h2v-2",
    fill: color,
    fillRule: "evenodd"
  }));
}
export default WarningOutline;